import { Sidebar } from "./Sidebar";

interface DesktopLayoutProps {
  children: React.ReactNode;
}

export function DesktopLayout({ children }: DesktopLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      <Sidebar />
      <main className="ml-16 lg:ml-64 min-h-screen transition-all duration-300">
        {children}
      </main>
    </div>
  );
}
